module.exports = __webpack_public_path__ + "assets/6aa42e607b1ca38388ec7e5aa9b3179d.png";